'use client';

import { IntlFileKind } from '@/lib/recruitment/intl-application';
import { FileUploadCard } from '@/components/recruitment/intl/FileUploadCard';
import { StepNav } from '@/components/recruitment/intl/steps/StepNav';

export function IdentityStep({
  token,
  labels,
  files,
  onUploaded,
  onExpired,
  onBack,
  onContinue,
}: {
  token: string;
  /** Upload labels and hints as worded in Recruitment -> Job Applications. */
  labels?: Record<string, { label: string; hint: string }>;
  files: Partial<Record<IntlFileKind, string | null>>;
  onUploaded: (kind: IntlFileKind, fileName: string, completedSteps: string[]) => void;
  onExpired: () => void;
  onBack: (() => void) | null;
  onContinue: () => void;
}) {
  const bothUploaded = !!files.gov_id && !!files.selfie_with_id;

  return (
    <div className="space-y-4">
      <p className="text-sm text-gray-400">
        Upload two photos so we can verify your identity. Make sure the text on your ID is
        readable and your face is clearly visible.
      </p>
      <FileUploadCard
        token={token}
        kind="gov_id"
        label={labels?.gov_id?.label}
        hint={labels?.gov_id?.hint || "A clear photo of your passport, driver's license, UMID, or national ID."}
        fileName={files.gov_id ?? null}
        onUploaded={onUploaded}
        onExpired={onExpired}
      />
      <FileUploadCard
        token={token}
        kind="selfie_with_id"
        label={labels?.selfie_with_id?.label}
        hint={labels?.selfie_with_id?.hint || 'A selfie of you holding the same ID next to your face.'}
        capture="user"
        fileName={files.selfie_with_id ?? null}
        onUploaded={onUploaded}
        onExpired={onExpired}
      />
      <StepNav
        onBack={onBack}
        onContinue={onContinue}
        continueDisabled={!bothUploaded}
        disabledHint="Upload both photos to continue."
      />
    </div>
  );
}
